import { css } from 'linaria';

export const common = css`
  background-color: var(--background-primary);
`;

export const important = css`
  background-color: var(--secondary-yellow-primary);
`;

export const critical = css`
  color: var(--text-invert);
  background-color: var(--attention-primary);

  svg {
    --i-color: var(--text-invert);
    --i-s-width: 1.25;
  }
`;

export const container = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-150);
`;
